import { newsData } from '../../../mocks/news';

const NewsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-primary-light">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-1/4">
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
              お知らせ
            </h2>
            <p className="text-gray-600">NEWS</p>
          </div>

          <div className="lg:w-3/4 space-y-4">
            {newsData.map((news) => (
              <article
                key={news.id}
                className="bg-white rounded-2xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer"
              >
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <time className="flex-shrink-0 w-24 h-12 bg-primary text-white rounded-lg flex items-center justify-center font-bold text-sm">
                    {news.date}
                  </time>
                  <span className="flex-shrink-0 px-3 py-1 bg-primary/10 text-primary text-xs font-bold rounded-full">
                    {news.category}
                  </span>
                  <h3 className="flex-1 text-base md:text-lg font-medium text-gray-900">
                    {news.title}
                  </h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
